import {IPoint} from "../interfaces/IPoint";
import {IVector} from "../interfaces/IVector";
import {Point} from "./Point";


export class Vector implements IVector {

    public start: IPoint;
    public end: IPoint;

    constructor(start: IPoint, end: IPoint) {
        this.end = end;
        this.start = start;
    }

    public static fromPointList(points: Array<Point>) : IVector {
        return new Vector(points[0], points[1]);
    }

}
